import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import {IMaskInput} from 'react-imask';

export default observer((props) => {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <IMaskInput
      type="text"
      mask={Number}
      disabled={props.disabled?true:false}
      className="w100"
      scale={0}
      signed={true}
      placeholder={props.placeholder}
      inputRef={(ref)=>{ if(props.inputRef) { props.inputRef(ref); } }}
      value={""+props.linker.value}
      onAccept={(value)=>{
        runInAction(()=>{
          props.linker.value=parseInt(value);
        })
      }}
    />
  )

});